<template>
  <div>
    <template v-if="!isUserAuth">
      <p class="auth-title">
        {{ $t('loyalty.auth.title') }}
      </p>
      <div class="auth-form">
        <div class="auth-form__phone">
          <p class="form-label">
            {{ $t('loyalty.auth.by_phone') }}
          </p>
          <AuthPhone
            is-ajax-auth
            is-hidden-labels
            :remember-field="false"
          ></AuthPhone>
        </div>
        <div class="form__hr"></div>

        <div>
          <p class="form-label">
            {{ $t('loyalty.auth.by_socials') }}
          </p>
          <div class="form__social-btns">
            <a @click.prevent="openSocialAuth"
               href="/auth/?authclient=facebook"
               class="form__social-btn form__social-btn--fb">
              <img class="form__social-btn-icon" src="/img/svgo/social/fb-icon.svg" alt="Facebook icon">
              Facebook
            </a>
            <a @click.prevent="openSocialAuth"
               href="/auth/?authclient=google"
               class="form__social-btn form__social-btn--g">
              <img class="form__social-btn-icon" src="/img/svgo/social/g-icon.svg" alt="Google icon">
              Google
            </a>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="bonuses-info">
        <img src="/img/svgo/product-page/bonus_icon.svg" alt="bonus icon" class="bonuses-info__icon">
        <span class="bonuses-info__text" v-html="$t('loyalty.bonus_info_text')"></span>
        <span class="bonuses-info__price">{{ totalBonusesInCurrency || 0 | CurrencyFormatter
        }}<small> грн</small></span>
      </div>
    </template>
  </div>
</template>

<script>
import AuthPhone from '@/components/auth/AuthPhone'
import CurrencyFormatter from '@/filters/CurrencyFormatter'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'LoyaltyProgramAuth',
  filters: {
    CurrencyFormatter
  },
  components: {
    AuthPhone
  },
  computed: {
    ...mapState({
      isUserAuth: state => state.user.auth
    }),
    ...mapGetters(['totalBonusesInCurrency'])
  },
  methods: {
    openSocialAuth (e) {
      localStorage.setItem('redirect-route', window.location.href)

      window.open(e.currentTarget.getAttribute('href'), '_blank', 'width= 860,height=480')
    }
  }
}
</script>

<style scoped lang="sass">
.auth-form
  +mmin($tablet)
    display: flex

.auth-title
  font-size: 18px
  color: $text-color
  margin: 0 0 25px
  +mmin($tablet)
    margin: 0 0 45px
    font-size: 24px

.auth-form__phone
  min-width: 180px

.form__hr
  text-align: center
  margin: 25px 0
  position: relative
  height: 1px
  background-color: $nd-border-color
  +mmin($tablet)
    height: auto
    width: 1px
    min-width: 1px
    align-self: stretch
    margin: 0 45px

.form__social-btns
  display: flex

.form__social-btn
  display: inline-block
  position: relative
  width: 50%
  max-width: 170px
  padding: 0 28px 0 60px
  line-height: 40px
  border-radius: 3px
  border: 1px solid $nd-border-color
  color: $text-color
  background-color: #fff
  font-size: 14px
  font-weight: 500
  &:first-child
    margin-right: 10px

  &:hover,
  &:focus
    border-color: $nd-focus-border-color

  +mmin(450)
    .form__social-btn
      padding: 0 33px 0 70px

.form__social-btn-icon
  position: absolute
  width: 26px
  height: 26px
  left: 20px
  top: 50%
  transform: translateY(-50%)

  @media only screen and (min-width: 450px)
    left: 25px

.form-label
  margin: 0 0 15px
  color: $nd-label-color

+mmin($tablet)
  ::v-deep
    .control-box.control-box--phone
      width: 100%
      margin-right: 0

    .control-box.control-box--code
      min-width: 110px

    .form-group--two-box
      margin-bottom: 0

.bonuses-info
  padding: 20px 15px
  border-radius: 3px
  background-image: url("data:image/svg+xml;utf8,<svg width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><rect width='100%' height='100%' style='fill: none; stroke: rgba(144, 144, 144, 0.5); stroke-width: 1; stroke-dasharray: 5 5'/></svg>")
  display: inline-flex
  align-items: center
  width: 500px
  max-width: 100%
  background-color: #fff
  color: $text-color
  margin-top: 30px
  &__icon
    margin-right: 15px
    width: 35px
    min-width: 35px
    height: 35px
  &__text
    font-size: 14px
    max-width: 140px
    margin-right: 20px
  &__price
    font-size: 36px
    line-height: 1.25
    font-weight: 500
    margin-left: auto
    align-self: flex-end
    white-space: nowrap
    small
      font-size: 18px
  +mmin($extsmall--hor)
    padding: 20px 25px
    &__icon
      width: 50px
      min-width: 50px
      height: 50px
      margin-right: 25px
    &__text
      font-size: 16px
      max-width: 180px
    &__price
      font-size: 48px
</style>
